import styled, { css } from "styled-components";

export const Section = styled.section`
    background-color: ${p => p.theme.c.light};
    overflow: hidden;
    padding-top: 28px;
    margin-top: -1px;
`;

export const Ribbon = styled.div`
    ${p =>
        p.theme.md.min(css`
            height: 607px;
        `)}

    width: 100%;
    margin-bottom: -243px;
    position: relative;

    ${p =>
        p.theme.xs(css`
            height: 486px;
            margin-bottom: -30px;
        `)}

    ${p =>
        p.theme.md.only(css`
            margin-bottom: -193px;
            height: 500px;
        `)}

    ${p =>
        p.theme.sm.only(css`
            margin-bottom: -193px;
            height: 500px;
        `)}

    .RibbonWrapper {
        height: 100%;
        z-index: 1;
        position: relative;
    }

    .UpperRibbon {
        position: absolute;
        top: -28px;
        height: 28px;
        background-color: ${p => p.theme.c.info};
        width: 100%;
        transform: skewY(5.9deg);
        transform-origin: top left;

        ${p =>
            p.theme.xs(css`
                height: 100px;
                transform: none;
            `)}
    }

    .LowerShadow {
        position: absolute;
        top: 268px;
        height: 5px;
        box-shadow: 0 2px 16px 4px ${p => p.theme.c.blackShadow4};
        width: 100%;
        transform: skewY(15.7deg);
        transform-origin: top left;

        ${p =>
            p.theme.md.only(css`
                top: 219px;
            `)}

        ${p =>
            p.theme.sm.only(css`
                top: 220px;
                transform: skewY(20.05deg);
            `)}

        ${p =>
            p.theme.xs(css`
                bottom: 61px;
                top: auto;
            `)}
    }

    h3, p {
        margin: 0;
    }
    h3 {
        font-size: 28px;
        color: ${p => p.theme.c.info};
        font-weight: 400;
        margin-bottom: 8px;

        ${p =>
            p.theme.md.only(css`
                font-size: 24px;
                margin-bottom: 4px;
            `)}

        ${p =>
            p.theme.sm.only(css`
                font-size: 24px;
                margin-bottom: 4px;
            `)}

        ${p =>
            p.theme.xs(css`
                font-size: 20px;
                margin-bottom: 4px;
            `)}
    }
    p {
        font-size: 24px;
        line-height: 1.5;
        color: ${p => p.theme.c.snowOnActive};
        font-weight: 300;
        text-align: justify;

        ${p =>
            p.theme.md.only(css`
                font-size: 20px;
            `)}

        ${p =>
            p.theme.sm.only(css`
                font-size: 18px;
            `)}

        ${p =>
            p.theme.xs(css`
                font-size: 17px;
            `)}
    }


    .Container {
        position: relative;
        width: 642px;
        z-index: 5;

        ${p =>
            p.theme.md.only(css`
                width: 350px;
            `)}

        ${p =>
            p.theme.sm.only(css`
                width: 300px;
            `)}

        ${p =>
            p.theme.xs(css`
                padding: 16px;
                padding-top: calc(80% - 10px);
                width: auto;
                position: static;
            `)}
    }

    &.Ribbon1, &.Ribbon3 {
        z-index: 5;
        clip-path: polygon(0 -28px, 0 50%, calc(100% + 1px) 105%, calc(100% + 1px) 121px - 28px);

        ${p =>
            p.theme.md.only(css`
                clip-path: polygon(0 -28px, 0 50%, calc(100% + 1px) 105%, calc(100% + 1px) 101px - 28px);
            `)}

        ${p =>
            p.theme.sm.only(css`
                clip-path: polygon(0 -28px, 0 50%, calc(100% + 1px) 105%, calc(100% + 1px) 50px);
            `)}

        ${p =>
            p.theme.xs(css`
                clip-path: polygon(0 -28px, 0 100%, calc(100% + 1px) 105%, calc(100% + 1px) 8px);
            `)}
        .RibbonWrapper {
            clip-path: polygon(0 0, 0 45%, calc(100% + 1px) 100%, calc(100% + 1px) 121px);
            ${p =>
                p.theme.md.only(css`
                    clip-path: polygon(0 0, 0 45%, calc(100% + 1px) 100%, calc(100% + 1px) 101px);
                `)}

            ${p =>
                p.theme.sm.only(css`
                    clip-path: polygon(0 0, 0 45%, calc(100% + 1px) 100%, calc(100% + 1px) 76px);
                `)}

            ${p =>
                p.theme.xs(css`
                    clip-path: polygon(0 0, 0 427px, calc(100% + 1px) 100%, calc(100% + 1px) 36px);
                `)}
            /* background-color: ${p => p.theme.c.boost}; */
            background-color: #00998e;
        }
        .Container {
            top: 62px;
            left: 120px;
            width: 652px;

            ${p =>
                p.theme.md.only(css`
                    top: 42px;
                    left: 64px;
                    width: 520px;
                `)}

            ${p =>
                p.theme.sm.only(css`
                    top: 27px;
                    left: 32px;
                    width: 400px;
                `)}

            ${p =>
                p.theme.xs(css`
                    padding-top: 30px;
                    position: static;
                    width: auto;
                `)}
        }
        img {
            width: 352px;
            position: absolute;
            right: 40px;
            top: 103px;
            clip-path: polygon(1% 1%, 1% 99%, 99% 99%, 99% 1%);

            ${p =>
                p.theme.md.only(css`
                    width: 289px;
                    right: 66px;
                    top: 78px;
                `)}

            ${p =>
                p.theme.sm.only(css`
                    width: 295px;
                    right: 20px;
                    top: 63px;
                `)}

            ${p =>
                p.theme.xs(css`
                    width: 260px;
                    right: calc((100vw - 260px) / 2);
                    bottom: -133px;
                    top: auto;
                `)}

        }
    }

    &.Ribbon2, &.Ribbon4 {
        z-index: 4;
        clip-path: polygon(0 121px - 28px, 0 105%, calc(100% + 1px) 50%, calc(100% + 1px) 0 - 28px);

        ${p =>
            p.theme.md.only(css`
                clip-path: polygon(0 101px - 28px, 0 105%, calc(100% + 1px) 50%, calc(100% + 1px) 0 - 28px);
            `)}

        ${p =>
            p.theme.sm.only(css`
                clip-path: polygon(0 101px - 28px, 0 105%, calc(100% + 1px) 50%, calc(100% + 1px) 0 - 28px);
            `)}

        ${p =>
            p.theme.xs(css`
                margin-bottom: 20px;
                clip-path: polygon(0 3px, 0 105%, calc(100% + 1px) 100%, calc(100% + 1px) -36px);
            `)}

        .RibbonWrapper {
            clip-path: polygon(0 121px, 0 100%, calc(100% + 1px) 45%, calc(100% + 1px) 0);
            ${p =>
                p.theme.md.only(css`
                    clip-path: polygon(0 101px, 0 100%, calc(100% + 1px) 45%, calc(100% + 1px) 0);
                `)}

            ${p =>
                p.theme.sm.only(css`
                    clip-path: polygon(0 101px, 0 100%, calc(100% + 1px) 45%, calc(100% + 1px) 0);
                `)}

            ${p =>
                p.theme.xs(css`
                    clip-path: polygon(0 36px, 0 100%, calc(100% + 1px) calc(100% - 60px), calc(100% + 1px) 0);
                `)}
            background-color: #a6d9d4;
            /* background-color: ${p => p.theme.c.pale}; */
        }
        .UpperRibbon {
            transform: skewY(-5.9deg);
            transform-origin: top right;
            ${p =>
                p.theme.xs(css`
                    height: 100px;
                    transform: none;
                `)}

            ${p =>
                p.theme.sm.only(css`
                    transform: skewY(-7.7deg);
                `)}
        }

        .LowerShadow {
            transform: skewY(-15.75deg);
            transform-origin: top right;
            ${p =>
                p.theme.sm.only(css`
                    top: 220px;
                    transform: skewY(-20.05deg);
                `)}
            ${p =>
                p.theme.xs(css`
                    bottom: 60px;
                    top: auto;
                `)}
        }
        p, h3 {
            color: ${p => p.theme.c.dark};
        }

        .Container {
            top: 118px;
            left: 330px;
            height: 280px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            
            ${p =>
                p.theme.lg(css`
                    width: 538px;
                `)}

            ${p =>
                p.theme.md.only(css`
                    top: 103px;
                    left: 280px;
                    width: 518px;
                    height: 200px;
                `)}

            ${p =>
                p.theme.sm.only(css`
                    top: 80px;
                    left: 259px;
                    width: 295px;
                    height: 250px;
                `)}

            ${p =>
                p.theme.xs(css`
                    padding-top: 60px;
                    display: block;
                    height: auto;
                `)}
        }

        img {
            position: absolute;
            width: 334px;
            left: 9px;
            top: 119px;
            clip-path: polygon(1% 1%, 1% 99%, 99% 99%, 99% 1%);
            ${p =>
                p.theme.md.only(css`
                    width: 303px;
                    left: -4px;
                    top: 91px;
                `)}

            ${p =>
                p.theme.sm.only(css`
                    width: 303px;
                    left: -17px;
                    top: 90px;
                `)}

            ${p =>
                p.theme.xs(css`
                    width: 260px;
                    right: calc((100vw - 250px) / 2);
                    bottom: -211px;
                    top: auto;
                    left: auto;
                `)}
        }
    }

    &.Ribbon3 {
        z-index: 3;
    }

    &.Ribbon3 {
        pointer-events: none;
        clip-path: polygon(0 -28px, 0 50%, calc(100% + 1px) 105%, calc(100% + 1px) 121px - 28px);

        ${p =>
            p.theme.md.only(css`
                clip-path: polygon(0 -28px, 0 50%, calc(100% + 1px) 105%, calc(100% + 1px) 101px - 28px);
            `)}

        ${p =>
            p.theme.sm.only(css`
                clip-path: polygon(0 -28px, 0 50%, calc(100% + 1px) 105%, calc(100% + 1px) 50px);
            `)}

        ${p =>
            p.theme.xs(css`
                clip-path: polygon(0 -28px, 0 100%, calc(100% + 1px) 105%, calc(100% + 1px) 8px);
            `)}

        .RibbonWrapper {
            clip-path: polygon(0 0, 0 45%, calc(100% + 1px) 100%, calc(100% + 1px) 121px);
            ${p =>
                p.theme.md.only(css`
                    clip-path: polygon(0 0, 0 45%, calc(100% + 1px) 100%, calc(100% + 1px) 101px);
                `)}

            ${p =>
                p.theme.sm.only(css`
                    clip-path: polygon(0 0, 0 45%, calc(100% + 1px) 100%, calc(100% + 1px) 76px);
                `)}

            ${p =>
                p.theme.xs(css`
                    clip-path: polygon(0 0, 0 427px, calc(100% + 1px) 100%, calc(100% + 1px) 36px);
                `)}
            background-color: ${p => p.theme.c.boost};
        }
        .Container {
            top: 131px;
            left: 409px;

            height: 200px;
            display: flex;
            ${p =>
                p.theme.sm.min(css`
                    justify-content: center;
                `)}
            flex-direction: column;

            ${p =>
                p.theme.lg(css`
                    height: 230px;
                    width: 518px;
                `)}

            ${p =>
                p.theme.md.only(css`
                    top: 111px;
                    left: 369px;
                `)}

            ${p =>
                p.theme.sm.only(css`
                    top: 110px;
                    left: 236px;
                    height: 190px;
                `)}

            ${p =>
                p.theme.xs(css`
                    padding-top: 50px;

                    h3 {
                        text-align: left;
                    }
                `)}
        }

        h3 {
            text-align: right;
        }
        img {
            position: absolute;
            pointer-events: none;
            transform: rotate(0deg);
            width: 432px;
            right: -63px;
            top: 149px;
            clip-path: none;
            ${p =>
                p.theme.md.only(css`
                    display: none;
                    width: 515px;
                    right: -56px;
                    top: 124px;
                    clip-path: polygon(203px 6.3px, 487px 9.7px, 630px 439.2px, 141px 397.6px);
                `)}

            ${p =>
                p.theme.sm.only(css`
                    display: none;
                    width: 485px;
                    right: -56px;
                    top: 132px;
                    clip-path: polygon(203px 6.3px, 487px 9.7px, 630px 439.2px, 141px 397.6px);
                `)}

            ${p =>
                p.theme.xs(css`
                width: 290px;
                right: calc((100% - 310px) / 2);
                top: 258px;
                transform: rotate(0deg);
                clip-path: none;
            `)}
        }
    }
    &.Ribbon4 {
        z-index: 2;
        img {
            width: 274px;
            left: 29px;
            top: 169px;

            ${p =>
                p.theme.xs(css`
                    width: 200px;
                    right: calc((100vw - 230px) / 2);
                    bottom: -71px;
                    top: auto;
                    left: auto;
                `)}
        }
        

        .Container {
            left: 300px;
        }
    }
    &.Ribbon5 {
        z-index: 1;
        pointer-events: none;
        ${p =>
            p.theme.xs(css`
                display: none;
            `)}
    }

`;
